import authRoutes from './modules/auth'
import dashboardRoutes from './modules/dashboard'
import academicRoutes from './modules/academic'
import studentRoutes from './modules/student'
import teacherRoutes from './modules/teacher'
import staffRoutes from './modules/staff'
import financeRoutes from './modules/finance'
import taskRoutes from './modules/task'
import feedbackRoutes from './modules/feedback'
import settingsRoutes from './modules/settings'
import facilityRoutes from './modules/facility'
import salaryRoutes from './modules/salary'
import notificationRoutes from './modules/notification'

const routes = [
  {
    path: '/',
    component: () => import('../components/layout/GuestLayout'),
    children: authRoutes,
  },
  {
    path: '/',
    component: () => import('../components/layout/MainLayout'),
    meta: {
      title: 'Trang chủ',
    },
    children: [
      ...dashboardRoutes,
      ...academicRoutes,
      ...studentRoutes,
      ...teacherRoutes,
      ...staffRoutes,
      ...financeRoutes,
      ...taskRoutes,
      ...feedbackRoutes,
      ...settingsRoutes,
      ...facilityRoutes,
      ...salaryRoutes,
      ...notificationRoutes,
      {
        path: '*',
        name: 'page404',
        component: () => import('@/views/Page404'),
        meta: {
          title: 'Page not found',
        },
      },
    ],
  },
]
export default routes
